import { useEffect, useState } from 'react'

import { API } from '@/api'
import { PageLoading } from '@/components/PageLoading'

export function PaypalPaymentCallbackPage() {
  const [loading, setLoading] = useState(true)
  const closeWindow = (success: boolean) => {
    window.opener?.postMessage({ id: 'glows-paypal', success }, '*')
    window.close()
  }
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const paymentCode = urlParams.get('paymentCode')
    if (paymentCode) {
      API.capture({ code: paymentCode })
        .then((response) => {
          closeWindow(response.code === 0)
        })
        .catch(() => {
          closeWindow(false)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])
  return loading ? <PageLoading /> : <div>Successed</div>
}
